import { EventEmitter } from 'eventemitter3';
import { Env } from '../../Env';
import { createWorker } from '../../utils/workerUtils';
export class OpusEncoderWrapper extends EventEmitter {
    opusEncoderWorker;
    startWorker() {
        // Not DRY, but otherwise webpack won't transform the worker url
        if (Env.BUILD_TRANSFORMS_FILENAMES) {
            this.opusEncoderWorker = new Worker(new URL('./workers/opusencoder.worker.ts', import.meta.url));
        }
        else {
            this.opusEncoderWorker = createWorker('./workers/opusencoder.worker.js', import.meta.url);
        }
        this.opusEncoderWorker.onmessage = (e) => {
            const { type } = e.data;
            switch (type) {
                case 'encodedAudioData':
                    this.onEncodedAudioData(e.data.data);
                    break;
                case 'startCompleted':
                    this.emit('workerStarted');
                    break;
                case 'stopCompleted':
                    this.emit('workerStopped');
                    break;
            }
        };
        return new Promise((resolve, _reject) => {
            this.once('workerStarted', () => {
                resolve();
            });
            this.opusEncoderWorker?.postMessage({
                type: 'start',
            });
        });
    }
    stopWorker() {
        return new Promise((resolve, _reject) => {
            this.once('workerStopped', () => {
                this.opusEncoderWorker?.terminate();
                this.opusEncoderWorker = undefined;
                resolve();
            });
            this.opusEncoderWorker?.postMessage({
                type: 'stop',
            });
        });
    }
    onEncodedAudioData(audioData) {
        this.emit('encodedAudioData', audioData);
    }
    async encode(timestampMicros, data) {
        this.opusEncoderWorker?.postMessage({
            type: 'encode',
            timestampMicros,
            data,
        }, [data.buffer]);
    }
    async start() {
        return this.startWorker();
    }
    async stop() {
        return this.stopWorker();
    }
}
